import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Resolve,
} from '@angular/router';
import { Observable, BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { Juzgado } from 'src/app/core/models/juzgado.interface';
import { Page } from 'src/app/core/models/Page';

@Injectable()
export class ActiveLiquidationService implements Resolve<any> {

  constructor(private _http: HttpClient) {
    this.history = new BehaviorSubject([]);
    this.historyOtax = new BehaviorSubject([]);
    // this.debtTitle = new BehaviorSubject([]);
    this.page.size = 20;
    this.page.pageNumber = 0;
    this.page.state = 0;
  }
  debtTitle: BehaviorSubject<any>;
  history: BehaviorSubject<any>;
  historyOtax: BehaviorSubject<any>;
  routeParams: any;

  page: Page = new Page();
  values;

  resolve(
    router: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> | Promise<any> | any {
    this.routeParams = router.params.id;
    // this.getHistory(this.routeParams);
    // this.getDebtTitle(this.routeParams);
    return this.getLiquidation(this.page);
  }

  getLiquidation(page) {
    const httpParams = new HttpParams({
      fromObject: page,
    });
    return this._http.get(`${environment.BACKEND}liquidacion/listActive`, {
      params: httpParams,
    });
  }

  getLiquidationOtax(page) {
    const httpParams = new HttpParams({
      fromObject: page
    });
    return this._http.get(`${environment.BACKEND}liquidacion/listActive/otax`, {
      params: httpParams
    });
  }

  getLiquidationGant(page) {
    const httpParams = new HttpParams({
      fromObject: page
    });
    return this._http.get(`${environment.BACKEND}liquidacion/listActive/gant`, {
      params: httpParams
    });
  }

  getStageList(): Observable<any[]> {
    return this._http.get<any[]>(`${environment.BACKEND}liquidacion/stage`);
  }

  // Otax
  getPrecedenceStage(values): Observable<any> {
    const httpParams = new HttpParams({
      fromObject: values,
    });

    return this._http.get<any>(
      `${environment.BACKEND}liquidacion/precedences`,
      { params: httpParams }
    );
  }

// Gant
  getNextStage(id_liquidation): Observable<any[]> {
    return this._http.get<any[]>(
      `${environment.BACKEND}liquidacion/nextstage/${id_liquidation}`
    );
  }

  //
  getPossiblesNextStages(id_liquidations): Observable<any[]> {
    return this._http.post<any[]>(
      `${environment.BACKEND}liquidacion/nextstage-calculated`,
      { id_liquidations }
    );
  }

  getNextStageByStageId(id_stage): Observable<any[]> {
    return this._http.get<any[]>(`${environment.BACKEND}liquidacion/precedences/${id_stage}`);
  }

  getHistory(id): Promise<any> {
    return new Promise((resolve, reject) => {
      this._http
        .get(`${environment.BACKEND}liquidacion/history/${id}`)
        .pipe()
        .subscribe((data) => {
          this.history.next(data);
          resolve(this.history);
        }, reject);
    });
  }
 
  eliminarEtapas(values: any) {
    const httpParams = new HttpParams({
      fromObject: values
    });

    return this._http.get<any>(`${environment.BACKEND}liquidacion/consultar/eliminarEtapas`,
    { params: httpParams }
    );
  }


  historialEtapas(values: any) {
    const httpParams = new HttpParams({
      fromObject: values
    });

    return this._http.get<any>(`${environment.BACKEND}liquidacion/consultar/historialEtapas`,
    { params: httpParams }
    );
  }

  tiposBajas(): any {
    return this._http.get(`${environment.BACKEND}liquidacion/consultar/tiposBajas`);
  }
  
  deleteEtapa(values): any {
    return this._http.put<any>(`${environment.BACKEND}liquidacion/informar/eliminarEtapa`, values);
  }


  planDePago(values: any){ 
    const httpParams = new HttpParams({
      fromObject: values
    });

    return this._http.get<any>(`${environment.BACKEND}liquidacion/detallePlanPagoLiq`, 
    { params: httpParams }
    );
  }
  // getDebtTitle(id): Promise<any> {
  //   return new Promise((resolve, reject) => {
  //     this._http
  //       .get(`${environment.BACKEND}liquidacion/debt-title/${id}`)
  //       .pipe()
  //       .subscribe(data => {
  //         this.debtTitle.next(data);
  //         resolve(this.debtTitle);
  //       }, reject);
  //   });
  // }

  getFields(values) {
    const httpParams = new HttpParams({
      fromObject: values,
    });
    return this._http.get(`${environment.BACKEND}liquidacion/fields`, {
      params: httpParams,
    });
  }

  getJuzgado(): Observable<Juzgado[]> {
    return this._http.get<Juzgado[]>(`${environment.BACKEND}liquidacion/court`);
  }

  downloadDocument(fileName): Observable<Blob> {
    return this._http.get(
      `${environment.BACKEND}liquidacion/download/${fileName}`,
      { responseType: 'blob' }
    );
  }

  updateStage(values) {
    return this._http.post(
      `${environment.BACKEND}liquidacion/updateStage`,
      values
    );
  }

  // Nuevos endpoints Migracion RentasWEB Procuradores

  ultEtapaLiq(values) {
    const httpParams = new HttpParams({
      fromObject: values
    });

    return this._http.get(`${environment.BACKEND}liquidacion/ultEtapaLiq`, {
      params: httpParams
    });
  }

  histEtapaLiq(values) {
    const httpParams = new HttpParams({
      fromObject: values
    });

    return this._http.get(`${environment.BACKEND}liquidacion/histEtapaLiq`, {
      params: httpParams
    });
  }

  datosLiq(values) {
    console.log(values)
    const httpParams = new HttpParams({
      fromObject: values
    });

    return this._http.get(`${environment.BACKEND}liquidacion/datosLiq`, {
      params: httpParams
    });
  }

  histPlanPagoLiq(values) {
    const httpParams = new HttpParams({
      fromObject: values
    });

    return this._http.get(`${environment.BACKEND}liquidacion/histPlanPagoLiq`, {
      params: httpParams
    });
  }

    getPeriodoLiq(values) {
    const httpParams = new HttpParams({
      fromObject: values
    });

    return this._http.get(`${environment.BACKEND}liquidacion/getPeriodoLiq`, {
      params: httpParams
    });
  }

  gastosEventLiq(values) {
    const httpParams = new HttpParams({
      fromObject: values
    });

    return this._http.get(`${environment.BACKEND}liquidacion/gastosEventLiq`, {
      params: httpParams
    });
  }

  objetosLiq(values) {
    const httpParams = new HttpParams({
      fromObject: values
    });

    return this._http.get(`${environment.BACKEND}liquidacion/objetosLiq`, {
      params: httpParams
    });
  }

  getObjectDetail(values) {
    const httpParams = new HttpParams({
      fromObject: values
    });

    return this._http.get(`${environment.BACKEND}liquidacion/downDetalleObjetosLiq`, {
      params: httpParams
    });
  }

  domiciliosLiq(values) {
    const httpParams = new HttpParams({
      fromObject: values
    });

    return this._http.get(`${environment.BACKEND}liquidacion/domiciliosLiq`, {
      params: httpParams
    });
  }

  gestionDeudaLiq(values) {
    const httpParams = new HttpParams({
      fromObject: values
    });

    return this._http.get(`${environment.BACKEND}liquidacion/gestionDeudaLiq`, {
      params: httpParams
    })
  }

  getSimularDeudaLiq(values) {
    const httpParams = new HttpParams({
      fromObject: values
    });

    return this._http.get(`${environment.BACKEND}liquidacion/simularDeudaLiq`, {
      params: httpParams
    })
  }

  getLiqTramites(num_liquidacion){
    const httpParams = new HttpParams({
      fromObject: {
        num_liquidacion
      }
    });
    return this._http.get(`${environment.BACKEND}tramite/listTramites/liquidacion`, {
      params: httpParams
    })
  }

  downloadLiq(value){
    return this._http.post(`${environment.BACKEND}liquidacion/downloadPlanDeudaLiq`,  value)
  }

  submitStage(values) {
    return this._http.post(
      `${environment.BACKEND}liquidacion/informar/registrarEtapa`,
      values
    );
  }



  // Cambio masivo de etapas

  massiveStageUpdate(formdata) {
    return this._http.post(
      `${environment.BACKEND}liquidacion/informar/cargaMasiva`,
      formdata
    );
  }

  expedienteUpdate(values): any  {
    return this._http.post<any>(
      `${environment.BACKEND}maintenance/changeExpediente`,
      values 
    );
  }

  getFilteredEtapas(cuit) {
    const value = {
      CUIT_PROCURADOR: cuit.RCR_USUARIO_RECAUDADOR
    }

    const httpParams = new HttpParams({
      fromObject: value
    });
  
    return this._http.get(
      `${environment.BACKEND}liquidacion/getFilteredEtapas`, {
        params: httpParams
      }
    );
  }

  // Consulta de CUITs asociados al procurador

  getAssociatedCuits() {
    return this._http.get(
      `${environment.BACKEND}liquidacion/cuitFicticio`
    );
  }

  // Partes Procurador

  getPartesProcuByLiq(cuit, nro_liquidation, procuId, fechaDesde, fechaHasta, VIEWED) {
    const values = {
      CUIT_PROCURADOR: cuit,
      NRO_LIQUIDACION: nro_liquidation,
      ID_PROCU_SIST: procuId,
      VIEWED
    };

    if (fechaDesde) { values['FECHA_DESDE'] = fechaDesde; }
    if (fechaHasta) { values['FECHA_HASTA'] = fechaHasta; }

    const httpParams = new HttpParams({
      fromObject: values
    });

    return this._http.get(`${environment.BACKEND}liquidacion/getPartesProcuLiq`, {
      params: httpParams
    });
  }

  getPartesProcu(cuit, procuId, paginaNro, fechaDesde, fechaHasta, VIEWED) {
    const values = {
      CUIT_PROCURADOR: cuit,
      ID_PROCU_SIST: procuId,
      NRO_PAGINA: paginaNro,
      VIEWED
    };

    if (fechaDesde) { values['FECHA_DESDE'] = fechaDesde; }
    if (fechaHasta) { values['FECHA_HASTA'] = fechaHasta; }

    const httpParams = new HttpParams({
      fromObject: values
    });

    return this._http.get(`${environment.BACKEND}liquidacion/partesProcu`, {
      params: httpParams
    });
  }

  imprimirPartesProcu(nroPartes) {
    const listaNroPartes = nroPartes.map(e => e.NUMERO).join(',');
    const values = {
      PARTE_NUM:  listaNroPartes,
    };

    const httpParams = new HttpParams({
      fromObject: values
    });

    return this._http.get(`${environment.BACKEND}liquidacion/imprimirPartes`, {
      params: httpParams
    });
  }

  markAsReaded(nroParte) {
    return this._http.put(`${environment.BACKEND}liquidacion/viewedPartes`, {
      NUMERO: nroParte
    });
  }

}
